// src/components/audition-booking-wizard/Step5_ApplicationDetails.jsx
import React from 'react';
import { Button, Row, Col, Spinner, Alert, Badge, Form, ProgressBar } from 'react-bootstrap'; // ADDED ProgressBar
import { FaStar, FaVideo, FaCalendarAlt, FaClock, FaCheckCircle } from 'react-icons/fa';
import VideoPlayModal from './VideoPlayModal'; 
import { JOGET_BASE_URL } from './utils/bookingHelpers'; 
const BASE_URL = process.env.REACT_APP_API_URL.replace("/api", "");


const Step5_ApplicationDetails = ({
    loadingDetails, auditionDetails, apiError, applicationJogetId,
    showVideoModal, setShowVideoModal, activeVideoUrl, setActiveVideoUrl,
    selectedVideoFileForReupload, reuploadingVideo, reuploadProgress, reuploadError, reuploadFileInputRef,
    handleReuploadFileChange, handleReuploadButtonClick,showFeedbackModal,setShowFeedbackModal,directorId,roleId,mysqlApplicationId,
    handleReapply
}) => {
    if (loadingDetails) {
        return (
            <div className="text-center p-5">
                <Spinner className="text-white" animation="border" variant="danger" />
                <p className='text-white mt-3'>Loading audition details...</p>
            </div>
        );
    }

    if (!auditionDetails) {
        return <Alert variant="warning" className="m-3">No audition details found.</Alert>;
    }
    if (apiError) return <Alert variant="danger" className="m-3">{apiError}</Alert>;

    const isRefundedOrCancelled = auditionDetails?.bookingStatus === 'CANCELLED' || auditionDetails?.paymentStatus === 'REFUNDED';
    const resultStatus = isRefundedOrCancelled ? "CANCELLED & REFUNDED" : (auditionDetails?.result || "PENDING");
    const isFinalStatus = !isRefundedOrCancelled && (resultStatus === "SELECTED" || resultStatus === "REJECTED");
    const isResubmitRequest = !isRefundedOrCancelled && resultStatus === "RESUBMIT" && auditionDetails?.bookingType === "VIDEO_UPLOAD";

    return (
        <div className="application-dashboard animate-fade-in text-start">
            
            {/* STATUS ALERTS */}
            {isRefundedOrCancelled ? (
                <Alert variant="danger" className="text-start border-0 rounded-4 p-4 mb-3 shadow-sm" style={{ backgroundColor: 'rgba(239, 68, 68, 0.12)', border: '1px solid rgba(239, 68, 68, 0.4)' }}>
                    <div className="d-flex align-items-start justify-content-between flex-wrap gap-3">
                        <div>
                            <h5 className="text-danger fw-bold mb-2 d-flex align-items-center gap-2">
                                <span>⚠️</span> Audition Application Cancelled & Payment Refunded
                            </h5>
                            <p className="text-white mb-2" style={{ fontSize: '0.95rem' }}>
                                Your booking for <strong>{auditionDetails.roleName || 'this role'}</strong> ({auditionDetails.applicationId || ''}) has been cancelled and your payment {auditionDetails.totalAmount ? `of ₹${Number(auditionDetails.totalAmount).toFixed(2)}` : ''} has been refunded to your original payment method.
                            </p>
                            {auditionDetails.modified_by_admin && (
                                <p className="text-warning small mb-2 fst-italic">
                                    <strong>Admin Status:</strong> {auditionDetails.modified_by_admin}
                                </p>
                            )}
                            <p className="text-secondary small mb-0">
                                You can submit a new application for this role anytime or apply to other audition opportunities.
                            </p>
                        </div>
                        {handleReapply && (
                            <Button 
                                variant="danger" 
                                size="md" 
                                className="fw-bold px-4 py-2 rounded-pill shadow-sm d-inline-flex align-items-center gap-2"
                                style={{ background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)', border: 'none' }}
                                onClick={handleReapply}
                            >
                                🔄 Apply Again for this Role
                            </Button>
                        )}
                    </div>
                </Alert>
            ) : isFinalStatus ? (
                <Alert variant={resultStatus === "SELECTED" ? "success" : "danger"} className="text-center fw-bold border-0 rounded-3">
                    Your application has been {resultStatus}!
                </Alert>
            ) : null}

            <Row className="g-4 mt-2">
                {/* LEFT COLUMN: Application Details (Styled like your image) */}
                <Col lg={4}>
                    <div className="h-100 p-4 rounded-4" style={{ backgroundColor: '#111111', border: '1px solid #222' }}>
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom border-dark pb-3">
                            <h5 className="text-white mb-0 fw-bold">Overview</h5>
                            <Badge bg={
                                isRefundedOrCancelled ? 'danger' :
                                resultStatus === 'SELECTED' ? 'success' : 
                                resultStatus === 'REJECTED' ? 'danger' : 
                                resultStatus === 'RESUBMIT' ? 'warning' : 'secondary'
                            } className="px-3 py-2 rounded-pill">
                                {resultStatus}
                            </Badge>
                        </div>

                        <div className="d-flex justify-content-between align-items-center pb-1">
                            <label className="text-muted small fw-bold text-uppercase tracking-wider mb-1" style={{ fontSize: '11px', letterSpacing: '1px' }}>Application ID:</label>
                            <div className="text-white fw-bold fs-6">{auditionDetails.applicationId}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center pb-1">
                            <label className="text-muted small fw-bold text-uppercase tracking-wider mb-1" style={{ fontSize: '11px', letterSpacing: '1px' }}>Role</label>
                            {/* <div className="text-white fw-bold fs-6">{auditionDetails.roleName}</div> */}
                            <div className="role-title-custom"> {auditionDetails.roleName}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center pb-1">
                            <label className="text-muted small fw-bold text-uppercase tracking-wider mb-1" style={{ fontSize: '11px', letterSpacing: '1px' }}>Audition Mode</label>
                            <div className="text-white fw-bold fs-6">{auditionDetails.bookingType}</div>
                        </div>

                        {/* {
    auditionDetails?.bookingType === "ONLINE_MEETING" &&
    auditionDetails?.meetingLink &&
    new Date() <= new Date(auditionDetails.meetingEnd) && (

        <div className="mt-3 text-center">

            <Button
                variant="success"
                href={auditionDetails.meetingLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-100"
            >
                🎥 Join Meeting
            </Button>

            {
                auditionDetails?.meetingStart && (
                    <small className="text-muted d-block mt-2">
                        Meeting Time :
                        {" "}
                        {new Date(
                            auditionDetails.meetingStart
                        ).toLocaleString()}
                    </small>
                )
            }

        </div>
    )
} */}
                        {/* MEETING & SCHEDULE DETAILS CARD - ONLY VISIBLE FOR FACE TO FACE / MEETING AUDITION MODES */}
                        {(() => {
                            const bookingTypeLower = (auditionDetails?.bookingType || '').toLowerCase();
                            const isFaceToFaceOrMeeting = bookingTypeLower.includes('face') || bookingTypeLower.includes('f2f') || bookingTypeLower.includes('meeting');

                            if (!isFaceToFaceOrMeeting) return null;

                            const parseLocalDateTime = (dateStr) => {
                                if (!dateStr) return null;
                                const cleanStr = String(dateStr).replace("Z", "").replace("T", " ");
                                const d = new Date(cleanStr);
                                return isNaN(d.getTime()) ? null : d;
                            };

                            const startDate = parseLocalDateTime(auditionDetails?.meetingStart || auditionDetails?.auditionDate || auditionDetails?.slot_datetime);
                            const endDate = parseLocalDateTime(auditionDetails?.meetingEnd);
                            const now = new Date();

                            const formattedDateStr = startDate
                                ? startDate.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
                                : (auditionDetails?.auditionDate || 'N/A');

                            const formattedTimeStr = startDate
                                ? `${startDate.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true })}${endDate ? ` - ${endDate.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true })}` : ''}`
                                : (auditionDetails?.auditionTime || 'N/A');

                            const isLive = startDate && endDate ? (now >= startDate && now <= endDate) : false;
                            const isUpcoming = startDate ? (now < startDate) : true;

                            return (
                                <div className="mt-3 p-3 rounded-3 bg-dark border border-secondary">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <label className="text-warning small fw-bold text-uppercase tracking-wider m-0 d-flex align-items-center gap-1.5">
                                            <FaCalendarAlt className="me-1 text-warning" /> MEETING & SCHEDULE INFO
                                        </label>
                                        <Badge bg={isLive ? "danger" : isUpcoming ? "info" : "secondary"} className="px-2 py-1 d-inline-flex align-items-center gap-1">
                                            {isLive ? <><FaVideo className="me-1" /> LIVE NOW</> : isUpcoming ? <><FaClock className="me-1" /> Upcoming Slot</> : <><FaCheckCircle className="me-1" /> Completed</>}
                                        </Badge>
                                    </div>

                                    <div className="text-light small mb-2">
                                        <div><strong>Date & Time:</strong> {formattedDateStr}, {formattedTimeStr}</div>
                                    </div>

                                    {(auditionDetails?.meetingLink || isFaceToFaceOrMeeting) && (
                                        <Button
                                            variant="danger"
                                            href={auditionDetails?.meetingLink || `/meeting/audition-${auditionDetails.applicationId}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-100 fw-bold mt-2 shadow-sm d-inline-flex align-items-center justify-content-center gap-2"
                                        >
                                            <FaVideo /> Join Video Meeting
                                        </Button>
                                    )}
                                </div>
                            );
                        })()}
                        {/* Director's Feedback */}
                        {/* {(auditionDetails.review || auditionDetails.ratingStar > 0) && (
                            <div className="mt-2 p-1 rounded bg-dark border border-secondary">
                                <label className="text-warning small fw-bold text-uppercase tracking-wider mb-2">🎬 Feedback</label>
                                <p className="text-light small mb-2">{auditionDetails.review || "No written review."}</p>
                                {auditionDetails.ratingStar > 0 && (
                                    <div className="text-warning">
                                        {[...Array(5)].map((_, i) => (
                                            <FaStar key={i} className={i < auditionDetails.ratingStar ? "active" : "text-secondary"} />
                                        ))}
                                    </div>
                                )}
                            </div>
                        )} */}

                        {(auditionDetails.review || auditionDetails.modified_by_admin || auditionDetails.ratingStar > 0) && (
                            <div className="mt-2 p-1 rounded bg-dark border border-secondary">

                                <label className="text-warning small fw-bold text-uppercase tracking-wider mb-2">
                                🎬 Feedback
                                </label>

                                {/* ✅ FIXED LOGIC */}
                                {auditionDetails.modified_by_admin ? (
                                <p className="text-warning small mb-2">
                                    🛠 Admin: {auditionDetails.modified_by_admin}
                                </p>
                                ) : (
                                <p className="text-light small mb-2">
                                    🎬 Director: {auditionDetails.review || "No written review."}
                                </p>
                                )}

                                {auditionDetails.ratingStar > 0 && (
                                <div className="text-warning">
                                    {[...Array(5)].map((_, i) => (
                                    <FaStar
                                        key={i}
                                        className={i < auditionDetails.ratingStar ? "active" : "text-secondary"}
                                    />
                                    ))}
                                </div>
                                )}

                            </div>
                        )}

                        {/* {(auditionDetails.review || auditionDetails.modified_by_admin || auditionDetails.ratingStar > 0) && (
                            <div className="mt-2 p-1 rounded bg-dark border border-secondary">

                                <label className="text-warning small fw-bold text-uppercase tracking-wider mb-2">
                                🎬 Feedback
                                </label>

                                {auditionDetails.modified_by_admin && (
                                <p className="text-warning small mb-1">
                                    🛠 Admin: {auditionDetails.modified_by_admin}
                                </p>
                                )}

                                <p className="text-light small mb-2">
                                🎬 Director: {auditionDetails.review || "No written review."}
                                </p>

                                {auditionDetails.ratingStar > 0 && (
                                <div className="text-warning">
                                    {[...Array(5)].map((_, i) => (
                                    <FaStar
                                        key={i}
                                        className={i < auditionDetails.ratingStar ? "active" : "text-secondary"}
                                    />
                                    ))}
                                </div>
                                )}

                            </div>
                        )} */}

                        {/* {
                            resultStatus === "SELECTED" && (

                                <div className="mt-4 text-center">

                                    <Button
                                        className="casting-review-btn"
                                        onClick={() =>
                                            setShowFeedbackModal(true)
                                        }
                                    >

                                        Review Comment

                                    </Button>

                                </div>

                            )
                        } */}
                        { resultStatus === "SELECTED" && (
                                <div className="mt-4 p-3 rounded bg-dark border border-secondary">
                                    <label className="text-info small fw-bold text-uppercase tracking-wider mb-2">
                                        Your Feedback
                                    </label>
                                    <p className="text-light small mb-3">
                                        {
                                            auditionDetails?.candidateFeedbackReview
                                            || "No feedback submitted yet."
                                        }
                                    </p>
                                    {
                                        auditionDetails?.candidateFeedbackRating > 0 && (
                                            <div className="text-warning">
                                                {
                                                    [...Array(5)].map((_, i) => (
                                                        <FaStar
                                                            key={i}
                                                            className={
                                                                i < auditionDetails.candidateFeedbackRating
                                                                ? "active"
                                                                : "text-secondary"
                                                            }
                                                        />
                                                    ))
                                                }
                                            </div>
                                        )
                                    }
                                    {
                                        !auditionDetails?.candidateFeedbackReview && (
                                            <div className="text-center mt-3">
                                                <Button
                                                    className="casting-review-btn"
                                                    onClick={() =>
                                                        setShowFeedbackModal(true)
                                                    }
                                                >
                                                    Give Feedback
                                                </Button>
                                            </div>
                                        )
                                    }

                                </div>

                            )
                        }

                        {/* Resubmit Prompt */}
                        {isResubmitRequest && (
                            <div className="mt-4 p-4 rounded bg-danger bg-opacity-10 border border-danger text-center">
                                <h6 className="text-danger fw-bold">Re-Upload Requested</h6>
                                <p className="text-light small mb-3">The director requested a revised performance.</p>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-white-50">Upload New Video</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept="video/mp4,video/quicktime"
                                        onChange={handleReuploadFileChange}
                                        ref={reuploadFileInputRef}
                                        disabled={reuploadingVideo}
                                    />
                                </Form.Group>
                                {selectedVideoFileForReupload && !reuploadingVideo && (
                                    <Button variant="danger" size="sm" onClick={handleReuploadButtonClick} disabled={reuploadingVideo}>
                                        {reuploadingVideo ? <Spinner className="text-white" animation="border" size="sm" /> : 'Re-upload Video'}
                                    </Button>
                                )}
                                {reuploadingVideo && (
                                    <>
                                        <div className="mb-1 text-light small">Uploading...</div>
                                        <ProgressBar animated now={reuploadProgress} label={`${reuploadProgress}%`} className="mb-3" />
                                    </>
                                )}
                                {reuploadError && <Alert variant="danger" className="mt-2 py-2">{reuploadError}</Alert>}
                            </div>
                        )}

                        {isRefundedOrCancelled && handleReapply && (
                            <div className="mt-4 pt-3 border-top border-dark text-center">
                                <Button 
                                    variant="outline-danger" 
                                    className="w-100 fw-bold py-2 rounded-3 d-inline-flex align-items-center justify-content-center gap-2"
                                    onClick={handleReapply}
                                >
                                    🔄 Apply Again for this Role
                                </Button>
                            </div>
                        )}
                    </div>
                </Col>

                {/* RIGHT COLUMN: Media History / Grid */}
                <Col lg={8}>
                    <div className="h-100 p-4 rounded-4" style={{ backgroundColor: '#111111', border: '1px solid #222' }}>
                        <h5 className="text-white mb-4 fw-bold border-bottom border-dark pb-3">Media History</h5>

                        <div className="media-scroll-container d-flex flex-nowrap gap-3 overflow-auto pb-2">
                            {auditionDetails.videoHistory && auditionDetails.videoHistory.length > 0 ? (
                                auditionDetails.videoHistory.map((vid, index) => (
                                    <div 
                                        key={vid.id}
                                        className="media-grid-item position-relative rounded-4 overflow-hidden flex-shrink-0"
                                        style={{ 
                                            width: '180px', 
                                            height: '250px', 
                                            backgroundColor: '#000', 
                                            border: '1px solid #333',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => {
                                            setActiveVideoUrl(vid.video_url); 
                                            setShowVideoModal(true);
                                        }}
                                    >
                                        <Badge bg="danger" className="position-absolute top-0 start-0 m-2" style={{ zIndex: 3 }}>
                                            Ver {auditionDetails.videoHistory.length - index}
                                        </Badge>

                                        <div className="position-absolute w-100 h-100 d-flex flex-column align-items-center justify-content-center" style={{ zIndex: 2, background: 'rgba(0,0,0,0.5)' }}>
                                            <FaVideo className="text-white" size={24} />
                                            <span className="text-white mt-2 small fw-bold">Play Submission</span>
                                        </div>

                                        <video
                                            src={vid.video_url}
                                            className="w-100 h-100 object-fit-cover opacity-50"
                                        />
                                    </div>
                                ))
                            ) : (
                                <div className="text-center w-100 py-5 text-white border border-dashed rounded-4">
                                    No videos found in history.
                                </div>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            <VideoPlayModal
                show={showVideoModal}
                handleClose={() => setShowVideoModal(false)}
                videoUrl={activeVideoUrl}
                jogetApplicationId={applicationJogetId}
            />
        </div>
    );
};

export default Step5_ApplicationDetails;